import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';
import { createWallboard, updateWallboard, deleteWallboard, regenerateWallboard } from 'flow/actions/wallboard-actions';
import { userHasQueueWithOmniEnabled } from 'flow/selectors/selectors';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { getWallboardUrl, MAX_QUEUES_AMOUNT_WALLBOARD, MAX_AGENTS_AMOUNT_WALLBOARD, wallboardTypes, wallboardDataIsSufficientForSaving, generateWallboardDTOFromComponentFriendlyData, getWallboardCreateComponentFriendlyWallboardData } from 'flow/utils/wallboard-utils';
import { routes } from 'flow/types/routes';
import { selectUrl } from 'flow/selectors/DashboardsSelectors';
import { navigateBack } from 'flow/actions/navigate-actions';
import Loading from 'flow/components/ui-components/Loading';
import Page from 'flow/components/Setting/Page';
import DashboardHuntGroupsMultiple from 'flow/components/dashboard/DashboardHuntGroupsMultiple';
import DashboardTeamCustom from 'flow/components/dashboard/DashboardTeamCustom';
import DashboardSettingsCustomize from 'flow/components/dashboard/DashboardSettingsCustomize';
import DashboardSettingsVisibility from 'flow/components/dashboard/DashboardSettingsVisibility';
import DashboardButtonsModify from './DashboardButtonsModify';
import { generatePath } from 'flow/utils/router-utils';
import { jsx as _jsx } from "react/jsx-runtime";
var DashboardCreate = function DashboardCreate(_ref) {
  var dashboardKey = _ref.dashboardKey,
    boardType = _ref.boardType,
    dashboardFromStore = _ref.dashboardFromStore;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var dispatch = useAppDispatch();
  var history = useHistory();
  var _useModal = useModal(),
    openModal = _useModal.openModal;
  var _useParams = useParams(),
    extensionKey = _useParams.extensionKey;
  var dashboardUrl = useAppSelector(function (state) {
    return selectUrl(state, dashboardKey);
  });
  var userHasOmniQueue = useAppSelector(userHasQueueWithOmniEnabled);
  var isEditingExistingDashboard = !!dashboardKey;
  var _useState = useState(getWallboardCreateComponentFriendlyWallboardData(dashboardFromStore, boardType)),
    _useState2 = _slicedToArray(_useState, 2),
    dashboardDataForSaving = _useState2[0],
    setDashboardDataForSaving = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = useState('MAIN'),
    _useState6 = _slicedToArray(_useState5, 2),
    view = _useState6[0],
    setView = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    generatingNewWallboardUrl = _useState8[0],
    setGeneratingNewWallboardUrl = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    newWallboardUrlGenerated = _useState0[0],
    setNewWallboardUrlGenerated = _useState0[1];
  var handleWallboardDataChanged = function handleWallboardDataChanged(data) {
    setDashboardDataForSaving(data);
  };
  var handleSaveWallboard = function handleSaveWallboard() {
    if (!wallboardDataIsSufficientForSaving(dashboardDataForSaving)) {
      //Should never happen because the create/save button should be disabled if data is insufficient for saving
      return;
    }
    setIsLoading(true);
    var wallboardDTO = generateWallboardDTOFromComponentFriendlyData(dashboardDataForSaving);
    if (isEditingExistingDashboard) {
      var wallboardDTOWithKey = wallboardDTO.set('key', dashboardKey);
      dispatch(updateWallboard(wallboardDTOWithKey, dashboardKey)).then(function () {
        setIsLoading(false);
        handleBack();
      })["catch"](function () {
        setIsLoading(false);
      });
    } else {
      dispatch(createWallboard(wallboardDTO)).then(function (data) {
        setIsLoading(false);
        openModal('dashboardCreated', {
          url: getWallboardUrl(data['urlPath'])
        });
      })["catch"](function () {
        setIsLoading(false);
      });
    }
  };
  var handleGenerateNewWallboardUrl = function handleGenerateNewWallboardUrl() {
    setGeneratingNewWallboardUrl(true);
    dispatch(regenerateWallboard(dashboardKey)).then(function () {
      setNewWallboardUrlGenerated(true);
    })["finally"](function () {
      setGeneratingNewWallboardUrl(false);
    });
  };
  var handleBack = function handleBack() {
    if (view === 'SETTINGS' || view === 'VISIBILITY') {
      setView('MAIN');
    } else {
      dispatch(navigateBack(location));
    }
  };
  var handleDeleteWallboard = function handleDeleteWallboard() {
    setIsLoading(true);
    dispatch(deleteWallboard(dashboardKey))["finally"](function () {
      history.push(generatePath(routes['settings.dashboards'], {
        extensionKey: extensionKey
      }));
    });
  };
  var navigateToSettings = function navigateToSettings() {
    setView('SETTINGS');
  };
  var navigateToWallboardVisibilitySettings = function navigateToWallboardVisibilitySettings() {
    setView('VISIBILITY');
  };
  var getCreateEditDeleteButtons = function getCreateEditDeleteButtons() {
    return /*#__PURE__*/_jsx("div", {
      className: "end-0 px-3 py-1.5",
      children: /*#__PURE__*/_jsx(DashboardButtonsModify, {
        onClickSave: handleSaveWallboard,
        createIsAllowed: wallboardDataIsSufficientForSaving(dashboardDataForSaving),
        isEditingExistingDashboard: isEditingExistingDashboard,
        onClickDelete: handleDeleteWallboard
      })
    });
  };
  var onWallboardSettingSet = function onWallboardSettingSet(settingName, value) {
    var newData = dashboardDataForSaving.setIn(['settings', settingName], value);
    setDashboardDataForSaving(newData);
  };
  var getWallboardItem = function getWallboardItem(boardType) {
    if (view === 'SETTINGS') {
      var props = {
        dataPeriodTypeInit: dashboardDataForSaving.getIn(['settings', 'dataPeriodType']),
        dataPeriodInit: parseInt(dashboardDataForSaving.getIn(['settings', 'dataPeriod'])),
        serviceLevelPeriodInit: parseInt(dashboardDataForSaving.getIn(['settings', 'serviceLevelPeriod'])),
        serviceLevelWarningThresholdInit: parseInt(dashboardDataForSaving.getIn(['settings', 'serviceLevelWarningThreshold'])),
        onSettingSet: onWallboardSettingSet,
        boardType: boardType,
        userHasOmniQueue: userHasOmniQueue
      };
      return /*#__PURE__*/_jsx(DashboardSettingsCustomize, _objectSpread({}, props));
    } else if (view === 'VISIBILITY') {
      var _props = {
        dashboardUrl: dashboardUrl,
        displayLoadingNewUrl: generatingNewWallboardUrl,
        displayGenerationSuccessful: newWallboardUrlGenerated,
        onGenerateNewUrlClick: handleGenerateNewWallboardUrl
      };
      return /*#__PURE__*/_jsx(DashboardSettingsVisibility, _objectSpread({}, _props));
    } else {
      var navigateToVisibilitySettings = isEditingExistingDashboard ? navigateToWallboardVisibilitySettings : undefined;
      var _props2 = {
        wallboardData: dashboardDataForSaving,
        maxSelectionAmount: MAX_QUEUES_AMOUNT_WALLBOARD,
        onWallboardDataChanged: handleWallboardDataChanged,
        onNavigateToCustomizeSettings: navigateToSettings,
        onNavigateToVisibilitySettings: navigateToVisibilitySettings,
        userHasOmniQueue: userHasOmniQueue
      };
      switch (boardType) {
        case wallboardTypes.HUNT_GROUPS_MULTIPLE:
          return /*#__PURE__*/_jsx(DashboardHuntGroupsMultiple, _objectSpread({}, _props2));
        case wallboardTypes.TEAM_CUSTOM:
          _props2.maxSelectionAmount = MAX_AGENTS_AMOUNT_WALLBOARD;
          return /*#__PURE__*/_jsx(DashboardTeamCustom, _objectSpread({}, _props2));
        default:
          return null;
      }
    }
  };
  var getViewTitle = function getViewTitle() {
    if (view === 'VISIBILITY') {
      return i18next.t('wallboard.sharing');
    } else if (isEditingExistingDashboard) {
      return i18next.t('wallboard.update');
    } else {
      return i18next.t('wallboard.create_new');
    }
  };
  if (isLoading || isEditingExistingDashboard && !dashboardFromStore) {
    return /*#__PURE__*/_jsx(Loading, {});
  }
  return /*#__PURE__*/_jsx(Page, {
    header: getViewTitle(),
    onClickBack: handleBack,
    footer: view === 'MAIN' ? getCreateEditDeleteButtons() : null,
    children: getWallboardItem(dashboardDataForSaving.get('type'))
  });
};
export default DashboardCreate;